import styled from 'styled-components/macro'

const SearchResultContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 4px 0 rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border-radius: 4px;
  margin: 10px;
  padding: 20px 12px 12px;
`

export default SearchResultContent
